import React, { useState } from 'react';

const Mensajeria = () => {
  // Estado simulado para los contactos y mensajes
  const [contactos, setContactos] = useState([
    {
      id: 1,
      nombre: 'Ashley Briggs',
      avatar: 'https://via.placeholder.com/40',
      online: true,
      mensajes: [
        { id: 1, texto: 'Hola, ¿cómo estás?', enviadoPorUsuario: false, hora: '2:34 pm' },
        { id: 2, texto: 'Todo bien, gracias.', enviadoPorUsuario: true, hora: '2:35 pm' },
        { id: 3, texto: '¿Has revisado los documentos?', enviadoPorUsuario: false, hora: '2:36 pm' },
      ],
    },
    {
      id: 2,
      nombre: 'Carl Jenkins',
      avatar: 'https://via.placeholder.com/40',
      online: true,
      mensajes: [
        { id: 1, texto: 'Hola Carl, ¿tienes tiempo para una reunión?', enviadoPorUsuario: true, hora: '3:15 pm' },
        { id: 2, texto: 'Claro, ¿a qué hora?', enviadoPorUsuario: false, hora: '3:16 pm' },
        { id: 3, texto: 'A las 4 está perfecto.', enviadoPorUsuario: true, hora: '3:17 pm' },
      ],
    },
    {
      id: 3,
      nombre: 'Bertha Martin',
      avatar: 'https://via.placeholder.com/40',
      online: true,
      mensajes: [
        { id: 1, texto: 'Buenas tardes, Bertha.', enviadoPorUsuario: true, hora: '4:45 pm' },
        { id: 2, texto: 'Hola, ¿cómo te va?', enviadoPorUsuario: false, hora: '4:46 pm' },
        { id: 3, texto: 'Bien, gracias. ¿Y tú?', enviadoPorUsuario: true, hora: '4:47 pm' },
      ],
    },
  ]);

  const [contactoSeleccionado, setContactoSeleccionado] = useState(contactos[0]);
  const [nuevoMensaje, setNuevoMensaje] = useState('');

  const manejarSeleccionContacto = (contacto) => {
    setContactoSeleccionado(contacto);
  };

  const enviarMensaje = () => {
    if (nuevoMensaje.trim() !== '') {
      const mensaje = {
        id: Date.now(),
        texto: nuevoMensaje,
        enviadoPorUsuario: true,
        hora: new Date().toLocaleTimeString(),
      };

      const contactosActualizados = contactos.map((contacto) =>
        contacto.id === contactoSeleccionado.id
          ? { ...contacto, mensajes: [...contacto.mensajes, mensaje] }
          : contacto
      );

      setContactos(contactosActualizados);
      setNuevoMensaje('');
    }
  };

  return (
      <div className="container-fluid p-0">
        <h1 className="h3 mb-3">Mensajes</h1>

        <div className="card">
          <div className="row g-0">
            {/* Columna de Contactos */}
            <div className="col-12 col-lg-5 col-xl-3 border-end list-group">
              <div className="px-4 d-none d-md-block">
                <div className="d-flex align-items-start align-items-center">
                  <div className="flex-grow-1">
                    <input type="text" className="form-control my-3" placeholder="Buscar..." />
                  </div>
                </div>
              </div>

              {contactos.map((contacto) => (
                <a
                  key={contacto.id}
                  href="#"
                  className={`list-group-item list-group-item-action border-0 ${contactoSeleccionado.id === contacto.id ? 'active' : ''}`}
                  onClick={() => manejarSeleccionContacto(contacto)}
                >
                  <div className="d-flex align-items-start">
                    <img
                      src={contacto.avatar}
                      className="rounded-circle me-1"
                      alt={contacto.nombre}
                      width="40"
                      height="40"
                    />
                    <div className="flex-grow-1 ms-3">
                      {contacto.nombre}
                      <div className="small">
                        <span className={`fas fa-circle chat-${contacto.online ? 'online' : 'offline'}`}></span> {contacto.online ? 'Online' : 'Offline'}
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            {/* Columna de Mensajes */}
            <div className="col-12 col-lg-7 col-xl-9">
              <div className="py-2 px-4 border-bottom d-none d-lg-block">
                <div className="d-flex align-items-start align-items-center py-1">
                  <div className="position-relative">
                    <img
                      src={contactoSeleccionado.avatar}
                      className="rounded-circle me-1"
                      alt={contactoSeleccionado.nombre}
                      width="40"
                      height="40"
                    />
                  </div>
                  <div className="flex-grow-1 ps-3">
                    <strong>{contactoSeleccionado.nombre}</strong>
                    <div className="text-muted small">
                      {contactoSeleccionado.online ? <em>Typing...</em> : 'Offline'}
                    </div>
                  </div>
                </div>
              </div>

              <div className="position-relative">
                <div className="chat-messages p-4">
                  {/* Mensajes Simulados */}
                  {contactoSeleccionado.mensajes.map((mensaje, index) => (
                    <div
                      key={mensaje.id}
                      className={`chat-message-${mensaje.enviadoPorUsuario ? 'right' : 'left'} pb-4`}
                    >
                      <div>
                        <img
                          src={mensaje.enviadoPorUsuario ? 'https://via.placeholder.com/40' : contactoSeleccionado.avatar}
                          className="rounded-circle me-1"
                          alt={mensaje.enviadoPorUsuario ? 'Tú' : contactoSeleccionado.nombre}
                          width="40"
                          height="40"
                        />
                        <div className="text-muted small text-nowrap mt-2">{mensaje.hora}</div>
                      </div>
                      <div className={`flex-shrink-1 bg-body-tertiary rounded py-2 px-3 ${mensaje.enviadoPorUsuario ? 'me-3' : 'ms-3'}`}>
                        <div className="fw-bold mb-1">{mensaje.enviadoPorUsuario ? 'Tú' : contactoSeleccionado.nombre}</div>
                        {mensaje.texto}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex-grow-0 py-3 px-4 border-top">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Escribe tu mensaje"
                    value={nuevoMensaje}
                    onChange={(e) => setNuevoMensaje(e.target.value)}
                  />
                  <button className="btn btn-primary" onClick={enviarMensaje}>
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Mensajeria;
